/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { CardContent, Typography } from "@material-ui/core";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

/**
 * Displays developer docs for public web chat functions
 */
export const ScriptDocs = () => {
	return (
		<CardContent>
			<Typography>
				PACE web chat exposes a set of public function for developers, to set custom attributes for chats. These
				attributes will be placed on the final Amazon Connect Contact Trace Record (CTR).
			</Typography>

			<div
				style={{ backgroundColor: "#FDE68A", color: "#B45309", marginTop: 20, padding: 10, overflowWrap: "break-word" }}
			>
				{`DEPRECATION WARNING: Due to usage limitations, setting the 'userName' attribute as a query string parameter in
				the '<script>' tag is deprecated and will be removed in future versions of PACE. Instead, please use the function
				'window.paceWebChat.setChatUserName(userName)' documented below.`}
			</div>

			<div style={{ marginTop: 20 }}>
				<SyntaxHighlighter language="javascript" style={docco}>
					{`
/**
 * Sets the user name for the web chat. If this function is used to set the
 * user name, the user will not be prompted to enter it.
 * @param {string} userName
 */
 window.paceWebChat.setChatUserName(userName);

/**
 * Set any attribute value. Existing attribute with the same name will be replaced.
 * Attribute value must be a primitive (string, number, boolean...), arrays and
 * objects are not allowed. Attribute name cannot contain spaces in order to be saved
 * on the CTR. Value will be converted to a string before saving (CTR attributes must be a string).
 * @param {string} attributeName
 * @param {string} attributeValue
 */
window.paceWebChat.setChatAttribute(attributeName, attributeValue);

/**
 * Remove specific chat attribute by name
 * @param {string} attributeName
 */
window.paceWebChat.removeChatAttribute(attributeName);

/**
 * Remove all chat attributes
 */
window.paceWebChat.removeAllChatAttributes();

/**
 * Returns the attribute value if it exists
 * @param {string} attributeName
 * @returns attribute value or undefined
 */
window.paceWebChat.getChatAttribute(attributeName);

/**
 * Returns object containing all attributes
 * @returns attributes object
 */
window.paceWebChat.getAllChatAttributes();

/**
 * Starts new chat session.
 */
window.paceWebChat.startChat();

/**
 * Ends ongoing chat session.
 * @param {Object} options end session options
 * @param {Boolean} options.hideChat optionally hide chat widget after session is ended, defaults to false.
 */
window.paceWebChat.endChat({ hideChat: false });
        `}
				</SyntaxHighlighter>
			</div>
		</CardContent>
	);
};
